import { Box } from '@trmediaab/zebra';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { connect } from 'react-redux';

import PageMeta from '~/components/PageMeta';
import RoundNavigation from '~/components/RoundNavigation';
import Round from '~/containers/Round';

import Interviews from './Interviews';
import Legs from './Legs';
import LiveFeed from './LiveFeed';
import RoundOverview from './RoundOverview';
import Statistics from './Statistics';
import Systems from './Systems';

const RoundTip = ({ slug, leg_number = 1, view, location }) => {
  const renderPage = round => {
    switch (view) {
      case 'startlista':
      case 'tips':
        return (
          <Legs leg_number={leg_number} slug={slug} round={round} view={view} />
        );
      case 'intervjuer':
        return <Interviews leg_number={leg_number} slug={slug} round={round} />;
      case 'vara-spel':
        return <Systems round={round} />;
      case 'live':
        return ['V75', 'V86'].includes(round.bet_type) ? (
          <LiveFeed round={round} />
        ) : (
          <RoundOverview slug={slug} round={round} routeType={location.type} />
        );
      case 'statistik':
        return <Statistics round={round} />;
      default:
        return (
          <RoundOverview slug={slug} round={round} routeType={location.type} />
        );
    }
  };

  return (
    <Round
      slug={slug}
      leg={leg_number}
      render={round => {
        const meets = round.meets.map(meet => meet.track_name).join('/');
        return (
          <Fragment>
            <PageMeta
              meta={{
                title: `Travtips ${round.bet_type} ${meets} ${round.round_date}`,
              }}
            />

            <RoundNavigation
              slug={slug}
              leg_number={leg_number}
              view={view}
              round={round}
            />

            <Box
              mt={
                ['startlista', 'tips', 'intervjuer'].includes(view)
                  ? undefined
                  : { _: 3, md: '3,5' }
              }
            >
              {renderPage(round)}
            </Box>
          </Fragment>
        );
      }}
    />
  );
};

const mapStateToProps = state => ({
  location: state.location,
  ...state.location.payload,
});

RoundTip.propTypes = {
  slug: PropTypes.string.isRequired,
  leg_number: PropTypes.number,
  view: PropTypes.string,
  location: PropTypes.object,
};

export default connect(mapStateToProps)(RoundTip);
